module.exports = __webpack_public_path__ + "static/back-aa2956df98c9c1dfe027cb214340147a.png";